import { PermissionOperation } from 'generated/graphql';
import {
  PermissionResourceType,
  UserPermissionType,
} from 'v2/core/entities/user';

export const generateResourceOperationMap = (
  permissions: UserPermissionType[],
) => {
  const resourcePermissionMap = new Map<
    PermissionResourceType,
    PermissionOperation
  >();

  permissions.forEach((permission) => {
    resourcePermissionMap.set(permission.resource, permission.operation);
  });

  return resourcePermissionMap;
};
